export const whatHappenedData = {
  title: 'Please explain why you are contesting the ticket',
  imgObj: {
    src: 'https://media.product.which.co.uk/prod/images/original/c5511237a2d4-tooliconconversation.jpg',
    alt: '',
  },
  note: [
    'What you write here will appear in the final letter of the claim, so please be as clear as possible, including dates.',
  ],
  descriptiveText: ['Why was the ticket issued to you unfair or unreasonable?'],
  placeholderText: 'Eg. I paid for a ticket but got a penalty notice.',
}
